import { useState, useRef } from "react";

type ModalNavigatePage<T> = {
  id?: T;
  values?: any;
};

export function useModalNavigate<T>(form: any, defaultPage?: T) {
  const currentDrawerPages = useRef<ModalNavigatePage<T>[]>([]);

  const [currentPageId, setCurrentPageId] = useState<T>();

  const fetchBackDrawerPage = () => {
    currentDrawerPages.current = currentDrawerPages.current.filter(
      (drawerPage) => drawerPage.id !== currentPageId,
    );
    const currentDrawerPage = currentDrawerPages.current.at(0);

    setCurrentPageId(currentDrawerPage?.id || defaultPage);
  };

  const fetchChangeDrawerPage = (id: T) => {
    const currentDrawerPage = currentDrawerPages.current.at(0);
    const currentFormValues = form.getFieldsValue(true);

    currentDrawerPages.current = currentDrawerPages.current.filter(
      (drawerPage) => drawerPage.id !== id,
    );
    currentDrawerPages.current.unshift({
      id,
      values: { ...currentFormValues },
    });

    if (currentDrawerPage) {
      currentDrawerPage.values = { ...currentFormValues };
    }

    setCurrentPageId(id);
  };

  const fetchResetDrawerPageHistory = () => {
    currentDrawerPages.current = [];
    form.resetFields();
  };

  return {
    currentPageId,
    fetchBackDrawerPage,
    fetchChangeDrawerPage,
    fetchResetDrawerPageHistory,
  };
}
